import { datadogLogs } from '@datadog/browser-logs';

export async function copyToClipboard(text: string) {
  try {
    await navigator.clipboard.writeText(text);
  } catch (err) {
    datadogLogs.logger.error('Could not copy text: ', {}, err as Error);
  }
}
